module.exports = {
    R42_CARD_OFF: 'R42_CARD_OFF',
    R42_CARD_ON: 'R42_CARD_ON',
    R42_CARD_PENDING_DEACTIVATION: 'R42_CARD_PENDING_DEACTIVATION',
    R42_CARD_IS_NOT_ACTIVED: 'R42_CARD_IS_NOT_ACTIVED',
    R42_CARD_VIP: 'R42_CARD_VIP',
    R42_CARD_HAS_NEVER_BEEN_ACTIVATED: '0001-01-01',
};